/**
 * Add selection ability to a model
 */
import { SEATSTATUS, RENDERER_MODE, CHECKMARK, SEATRADIUS, TYPE } from '@/constants';
import SVG from 'svg.js';
import Application from '../application';

export interface SelectableRequirements {
  attributes: Record<string, any>;
  view: SVG.G;
  shape: SVG.Shape;
  app: Application;
  type: (typeof TYPE)[keyof typeof TYPE];
}

export const SelectableMixin = <T extends { new (...args: any[]): SelectableRequirements }>(base: T) => {
  return class SelectableMixin extends base {
    // declare attributes: Record<string, any>;
    // declare view: SVG.G;
    // declare shape: SVG.Shape;
    // declare app: Application;
    // declare type: (typeof TYPE)[keyof typeof TYPE];

    // hack because selectable depends on cartable but also the other way round
    declare inCart: boolean;

    isSelected = false;
    selectedShape: SVG.Shape | null = null;

    toggleSelectedClass() {
      if (this.isSelected) {
        if (!this.inCart) {
          this.view.addClass('selected');
          this.initSelectedShape();
        }
      } else {
        if (!this.inCart) {
          this.view.removeClass('selected');
          this.removeSelectedShape();
        } else if (RENDERER_MODE && this.app.props.isShowCart && this.inCart) {
          this.shape.removeClass('cart');
        }
      }
    }

    toggleStatus() {
      if (this.isSelected) {
        if (!this.inCart) {
          this.attributes.status = SEATSTATUS.SELECTED;
        }
      } else {
        this.attributes.status = SEATSTATUS.FREE;
      }
    }

    select() {
      this.selected = true;
      if (!this.selected) return false;
    }

    deselect() {
      this.selected = false;
    }

    toggleSelect() {
      this.selected = !this.selected;
    }

    setSelected(flag: boolean) {
      this.selected = flag;
    }

    initSelectedShape([cx, cy] = this.attributes.position) {
      (this.shape.node.parentNode as SVGElement).classList.add('selected');
      if (!RENDERER_MODE) return;
      if (this.type !== TYPE.SEAT && this.type !== TYPE.TABLESEAT) return;
      if (!this.selectedShape || !this.selectedShape.node) {
        const size = (SEATRADIUS - 1) * this.app.seatmap.scale;

        this.selectedShape = this.view
          .path(CHECKMARK.SHAPE)
          .size(size)
          .center(cx, cy)
          .stroke({ color: CHECKMARK.STROKE, width: 2 })
          .fill('none')
          .rotate(10);
      }
    }

    removeSelectedShape() {
      this.selectedShape && this.selectedShape.remove();
      this.selectedShape = null;
    }

    updateSelectedShape(x: number, y: number) {
      if (this.selectedShape) {
        const size = (SEATRADIUS - 1) * this.app.seatmap.scale;
        this.selectedShape.size(size).center(x, y);
      }
    }

    get selected() {
      return this.isSelected;
    }

    set selected(selected) {
      if (this.isSelected === selected || this.inCart) return;
      this.isSelected = selected;
      this.toggleSelectedClass();
      if (RENDERER_MODE) {
        this.toggleStatus();
      }
    }
  };
};
